var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-pill text-light mr-1",class:{
		'orange darken-2': _vm.expiring <= 30,
		'blue-grey lighten-3': _vm.expiring > 30 && _vm.license.approved,
		red: !_vm.license.approved
	}},[_vm._v(_vm._s(_vm.license.state)+" "),(_vm.expiring <= 30)?_c('span',[_vm._v("expiring in "+_vm._s(_vm.expiring)+" day"+_vm._s(_vm.expiring === 1 ? "" : "s")+".")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }